import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M7 12h13","key":"svg-1"}],["path",{"d":"M10 18h10","key":"svg-2"}]]

const IconMenuDeep = createReactComponent('outline', 'menu-deep', 'MenuDeep', __iconNode);

export default IconMenuDeep;